
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";

const CHARACTER_LIMIT_DEFAULT = 2000;

@Component
export default class AnswerBlockTextarea extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;
  @Prop({ type: Boolean, default: true }) readonly fit!: boolean;

  @Watch("input")
  updateAnswer(value: string) {
    if (this.index != null)
      SMQuestionnaire.updateAnswer({
        index: this.index,
        value,
        required: this.answerBlockData.is_required,
        answer_block_id: this.answerBlockData.ID,
        answer_block_alias: this.answerBlockData.answer_block_alias,
        loop_index: this.loopIndex,
        condition: this.answerBlockData.condition,
      });
  }

  input = "";

  created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );

    if (this.index != null && answer) this.input = answer.value;
  }

  getMaxlength(characterLimit: number) {
    if (!characterLimit) return CHARACTER_LIMIT_DEFAULT;

    return characterLimit;
  }
}
